import { memo } from 'react'
import MaterialTable, { MTableBodyRow } from 'material-table'
import { TablePagination, Typography } from '@material-ui/core'
import same from 'lodash/identity'

import TableToolbar from '../commons/TableToolbar'
import TableActionPopover from '../commons/TableActionPopover'

import { useGetUserSettings } from 'utils/customHooks/useGetUserSettings'
import { VALUES } from 'utils/constants'

import useVideoDropZoneStyles from './Components/DropZoneVideo/styles'

function ResultsTable({
   columns,
   tableData,
   isSearch,
   searchCallback = same,
   actionEdit = same,
   cleanCallback = same,
   order,
   parentChildData = undefined,
   customActions = undefined,
   header = true,
   onlyTable,
   toolbarTitle,
   ToolbarComponents,
   RowComponent,
   enableKey,
   disableEditAction
}) {
   const classes = useVideoDropZoneStyles()
   const { isInternalAdmin } = useGetUserSettings()
   const { data = [], pageSize, totalRows, pageNumber } = tableData

   const actions = customActions

   if (!customActions) {
      actions.push({
         icon: 'edit',
         disabled: disableEditAction,
         tooltip: 'Editar fila',
         onClick: (_, rowData) => actionEdit(rowData)
      })
   }

   const keyInternalAdminAction = () => {
      if ((data[0] && data[0].code && isInternalAdmin) || enableKey) {
         return rowData => ({
            icon: () => !!rowData?.code && <TableActionPopover data={rowData.code} />,
            tooltip: rowData?.code ? 'Ver Código' : ''
         })
      }
   }

   if (!data.length) {
      return <Typography className={classes.noResultsText}>No hay registros que mostrar</Typography>
   }

   const CustomRow = props => {
      return (
         <>
            <MTableBodyRow {...props} />
            <tr key={`custom-row-${props.data.id}`}>
               <th key={`custom-cell-${props.data.id}`} colSpan="50">
                  {RowComponent && RowComponent(props)}
               </th>
            </tr>
         </>
      )
   }

   return (
      <div className={classes.root}>
         <MaterialTable
            columns={columns}
            data={data}
            parentChildData={parentChildData}
            options={{
               actionsColumnIndex: -1,
               toolbar: isSearch,
               paging: isSearch,
               emptyRowsWhenPaging: false,
               header: header,
               headerStyle: {
                  textTransform: 'uppercase',
                  fontWeight: 400,
                  textAlign: 'center',
                  fontSize: '12px',
                  lineHeight: '16px',
                  borderTop: !isSearch ? '4px solid #3264DC' : ''
               },
               rowStyle: {
                  textAlign: 'center',
                  backgroundColor: '#FFF'
               }
            }}
            actions={[...actions, keyInternalAdminAction()].filter(Boolean)}
            onOrderChange={() => {
               searchCallback(null, {
                  order: order === 'asc' ? 'desc' : 'asc'
               })
            }}
            localization={{
               header: {
                  actions: 'ACCIÓN'
               },
               toolbar: {
                  searchTooltip: 'Buscar',
                  searchPlaceholder: 'Buscar'
               },
               pagination: VALUES.PAGINATION_CONFIG,
               body: {
                  emptyDataSourceMessage: 'No hay registros que mostrar'
               }
            }}
            components={{
               Pagination: props => (
                  <TablePagination
                     {...props}
                     rowsPerPage={pageSize}
                     count={totalRows}
                     page={pageNumber}
                     onChangePage={(_, page) => searchCallback(null, { page })}
                     onPageChange={(_, page) => searchCallback(null, { page })}
                     onChangeRowsPerPage={e => {
                        props.onChangeRowsPerPage && props.onChangeRowsPerPage(e)
                        const page = e.target.value * pageNumber >= totalRows ? 0 : pageNumber
                        searchCallback(null, { size: e.target.value, page })
                     }}
                     onRowsPerPageChange={e => {
                        props.onChangeRowsPerPage && props.onChangeRowsPerPage(e)
                        const page = e.target.value * pageNumber >= totalRows ? 0 : pageNumber
                        searchCallback(null, { size: e.target.value, page })
                     }}
                  />
               ),
               Toolbar: props => (
                  <TableToolbar
                     {...props}
                     toolbarTitle={toolbarTitle}
                     ToolbarComponents={ToolbarComponents}
                     cleanCallback={cleanCallback}
                     totalRows={totalRows}
                  />
               ),
               Row: props => <CustomRow {...props} />
            }}
         />
      </div>
   )
}

export default memo(ResultsTable)
